var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showEnabledFilter === 'order_identifier' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "order_identifier"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.order_identifier)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.order_identifier,
      expression: "value.order_identifier",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.order_identifier !== ''
    },
    attrs: {
      "id": "order_identifier",
      "name": "order_identifier",
      "type": "text",
      "placeholder": _vm.$t('omt.gui.orders.search.filters.placeholder.product-identifier'),
      "disabled": !_vm.isFieldEditable('order_identifier')
    },
    domProps: {
      "value": _vm.value.order_identifier
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "order_identifier", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm.showEnabledFilter === 'fulfilment_method' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "fulfilment_method"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.fulfilment_method)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.fulfilment_method,
      expression: "value.fulfilment_method"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.fulfilment_method !== ''
    },
    attrs: {
      "id": "fulfilment_method",
      "name": "fulfilment_method",
      "disabled": !_vm.isFieldEditable('fulfilment_method')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "fulfilment_method", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.fulfillmentMethods, function (display_name, identifier) {
    return _c('option', {
      domProps: {
        "value": identifier
      }
    }, [_vm._v(_vm._s(display_name))]);
  })], 2)]) : _vm.showEnabledFilter === 'dispatch_type' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "dispatch_type"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.dispatch_type)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.dispatch_type,
      expression: "value.dispatch_type"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.dispatch_type !== ''
    },
    attrs: {
      "id": "dispatch_type",
      "name": "dispatch_type",
      "disabled": !_vm.isFieldEditable('dispatch_type')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "dispatch_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.$store.state.dispatchTypes, function (type) {
    return _c('option', {
      domProps: {
        "value": type.identifier
      }
    }, [_vm._v(_vm._s(type.display_name))]);
  })], 2)]) : _vm.showEnabledFilter === 'dispatcher_type' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "dispatcher_type"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.dispatcher_type)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.dispatcher_type,
      expression: "value.dispatcher_type"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.dispatcher_type !== ''
    },
    attrs: {
      "id": "dispatcher_type",
      "name": "dispatcher_type",
      "disabled": !_vm.isFieldEditable('dispatcher_type')
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "dispatcher_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.filterDispatcherTypeChanged]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.dispatcherTypes, function (display_name, identifier) {
    return _c('option', {
      domProps: {
        "value": identifier
      }
    }, [_vm._v(_vm._s(display_name))]);
  })], 2)]) : _vm.showEnabledFilter === 'dispatcher_identifier' ? _c('b-col', [_vm.value.dispatcher_type !== '' ? _c('div', [_c('label', {
    attrs: {
      "for": "dispatcher_identifier"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.dispatcher_identifier)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.dispatcher_identifier,
      expression: "value.dispatcher_identifier"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.dispatcher_identifier !== ''
    },
    attrs: {
      "id": "dispatcher_identifier",
      "name": "dispatcher_identifier",
      "disabled": !_vm.isFieldEditable('dispatcher_identifier')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "dispatcher_identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.dispatchers, function (dispatcher) {
    return _c('option', {
      domProps: {
        "value": dispatcher.identifier
      }
    }, [_vm._v(_vm._s(dispatcher.display_name) + " (" + _vm._s(dispatcher.identifier) + ")")]);
  })], 2)]) : _vm._e()]) : _vm.showEnabledFilter === 'dispatch_request_status' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "dispatch_request_status"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.dispatch_request_status)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.dispatch_request_status,
      expression: "value.dispatch_request_status"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.dispatch_request_status !== ''
    },
    attrs: {
      "id": "dispatch_request_status",
      "name": "dispatch_request_status",
      "disabled": !_vm.isFieldEditable('dispatch_request_status')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "dispatch_request_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.dispatchRequestStatuses, function (display_name, status) {
    return _c('option', {
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(display_name))]);
  })], 2)]) : _vm.showEnabledFilter === 'hold_status' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "hold_status"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.hold_status)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.hold_status,
      expression: "value.hold_status"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.hold_status !== ''
    },
    attrs: {
      "id": "hold_status",
      "name": "hold_status",
      "disabled": !_vm.isFieldEditable('hold_status')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "hold_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.holdStatuses, function (status) {
    return _c('option', {
      domProps: {
        "value": status.identifier
      }
    }, [_vm._v(_vm._s(status.display_name))]);
  })], 2)]) : _vm.showEnabledFilter === 'sales_formula_identifier' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "sales_formula_identifier"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.sales_formula_identifier)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.sales_formula_identifier,
      expression: "value.sales_formula_identifier"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.sales_formula_identifier !== ''
    },
    attrs: {
      "id": "sales_formula_identifier",
      "name": "sales_formula_identifier",
      "disabled": !_vm.isFieldEditable('sales_formula_identifier')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "sales_formula_identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.$store.state.config['sales-formulas'], function (name, identifier) {
    return _c('option', {
      domProps: {
        "value": identifier
      }
    }, [_vm._v(_vm._s(name))]);
  })], 2)]) : _vm.showEnabledFilter === 'sales_channel_identifier' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "sales_formula_identifier"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.sales_channel_identifier)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.sales_channel_identifier,
      expression: "value.sales_channel_identifier"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.sales_channel_identifier !== ''
    },
    attrs: {
      "id": "sales_channel_identifier",
      "name": "sales_channel_identifier",
      "disabled": !_vm.isFieldEditable('sales_channel_identifier')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "sales_channel_identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.$store.state.config['sales-channels'], function (name, identifier) {
    return _c('option', {
      domProps: {
        "value": identifier
      }
    }, [_vm._v(_vm._s(name))]);
  })], 2)]) : _vm.showEnabledFilter === 'responsible_location_identifier' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "responsible_location_identifier"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.responsible_location_identifier)))]), _c('br'), _c('ModelSelect', {
    ref: "responsibleLocationInput",
    attrs: {
      "options": _vm.responsibleStoreOptionsForModelSelect
    },
    model: {
      value: _vm.value.responsible_location_identifier,
      callback: function ($$v) {
        _vm.$set(_vm.value, "responsible_location_identifier", $$v);
      },
      expression: "value.responsible_location_identifier"
    }
  })], 1) : _vm.showEnabledFilter === 'carrier_method' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "carrier_method"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.carrier_method)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.carrier_method,
      expression: "value.carrier_method"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.carrier_method !== ''
    },
    attrs: {
      "id": "carrier_method",
      "name": "carrier_method",
      "disabled": !_vm.isFieldEditable('carrier_method')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "carrier_method", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.$store.getters.carriersMethodOptions, function (method) {
    return _c('option', {
      domProps: {
        "value": method.id,
        "innerHTML": _vm._s(method.display_name)
      }
    });
  })], 2)]) : _vm.showEnabledFilter === 'payment_method' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "payment_method"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.payment_method)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.payment_method,
      expression: "value.payment_method"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.payment_method !== ''
    },
    attrs: {
      "id": "payment_method",
      "name": "payment_method",
      "disabled": !_vm.isFieldEditable('payment_method')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "payment_method", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.$store.getters.paymentMethodOptions, function (method) {
    return _c('option', {
      domProps: {
        "value": method.id,
        "innerHTML": _vm._s(method.display_name)
      }
    });
  })], 2)]) : _vm.showEnabledFilter === 'has_comments' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "has_comments"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.has_comments)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.has_comments,
      expression: "value.has_comments"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.has_comments !== ''
    },
    attrs: {
      "id": "has_comments",
      "name": "has_comments",
      "disabled": !_vm.isFieldEditable('has_comments')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "has_comments", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ja")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Nee")])])]) : _vm.showEnabledFilter === 'refunds' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "refunds"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.refunds)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.refunds,
      expression: "value.refunds"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.refunds !== ''
    },
    attrs: {
      "id": "refunds",
      "name": "refunds",
      "disabled": !_vm.isFieldEditable('refunds')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "refunds", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.refundsSearchOptions, function (display_name, value) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(display_name))]);
  })], 2)]) : _vm.showEnabledFilter === 'validation_status' ? _c('b-col', [_c('label', [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.validation_status)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.validation_status,
      expression: "value.validation_status"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.validation_status !== ''
    },
    attrs: {
      "disabled": !_vm.isFieldEditable('validation_status')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "validation_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(['released', 'on-hold'], function (value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": value
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(`omt.gui.orders.search.results.validation-status.${value}`)) + " ")]);
  })], 2)]) : _vm.showEnabledFilter === 'has_order_responsible_location' ? _c('b-col', [_c('label', [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.has_order_responsible_location)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.has_order_responsible_location,
      expression: "value.has_order_responsible_location"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.has_order_responsible_location !== ''
    },
    attrs: {
      "disabled": !_vm.isFieldEditable('has_order_responsible_location')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "has_order_responsible_location", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ja")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Nee")])])]) : _vm.showEnabledFilter === 'has_assign_error' ? _c('b-col', [_c('label', [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.has_assign_error)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.has_assign_error,
      expression: "value.has_assign_error"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.has_assign_error !== ''
    },
    attrs: {
      "disabled": !_vm.isFieldEditable('has_assign_error')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "has_assign_error", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.orders.search.filters.has-assign-error-options.0')))]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.orders.search.filters.has-assign-error-options.1')))]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.orders.search.filters.has-assign-error-options.2')))]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.orders.search.filters.has-assign-error-options.3')))])])]) : _vm.showEnabledFilter === 'order_placed_from' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "order_placed_from"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.order_placed_from)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.order_placed_from,
      expression: "value.order_placed_from"
    }],
    ref: "orderPlacedTo",
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.order_placed_from !== ''
    },
    attrs: {
      "id": "order_placed_from",
      "name": "order_placed_from",
      "type": "date",
      "max": _vm.value.order_placed_to,
      "min": _vm.minOrderPlacedFrom,
      "disabled": !_vm.isFieldEditable('order_placed_from')
    },
    domProps: {
      "value": _vm.value.order_placed_from
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "order_placed_from", $event.target.value);
      }
    }
  }), _c('small', [_c('a', {
    staticClass: "text-lowercase",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.value.order_placed_from = '';
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.empty')))])])]) : _vm.showEnabledFilter === 'order_placed_to' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "order_placed_to"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.order_placed_to)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.order_placed_to,
      expression: "value.order_placed_to"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.order_placed_to !== ''
    },
    attrs: {
      "id": "order_placed_to",
      "name": "order_placed_to",
      "type": "date",
      "min": _vm.value.order_placed_from,
      "disabled": !_vm.isFieldEditable('order_placed_to')
    },
    domProps: {
      "value": _vm.value.order_placed_to
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "order_placed_to", $event.target.value);
      }
    }
  }), _c('small', [_c('a', {
    staticClass: "text-lowercase",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.value.order_placed_to = '';
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.empty')))])])]) : _vm.showEnabledFilter === 'max_age_days' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "max_age_days"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.max_age_days)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.max_age_days,
      expression: "value.max_age_days"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.max_age_days !== ''
    },
    attrs: {
      "id": "max_age_days",
      "type": "number",
      "min": "0",
      "disabled": _vm.isSearchingForOrderPlacedFrom || _vm.isSearchingForOrderNumber || !_vm.isFieldEditable('max_age_days'),
      "required": "",
      "placeholder": _vm.isSearchingForOrderPlacedFrom || _vm.isSearchingForOrderNumber ? `nvt` : `Ongelimiteerd`
    },
    domProps: {
      "value": _vm.value.max_age_days
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "max_age_days", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Geteld vanaf '" + _vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.order_placed_to)) + "'")])]) : _vm.showEnabledFilter === 'promised_delivery_date' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "promised_delivery_date"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.promised_delivery_date)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.promised_delivery_date,
      expression: "value.promised_delivery_date"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.promised_delivery_date !== ''
    },
    attrs: {
      "id": "promised_delivery_date",
      "name": "promised_delivery_date",
      "type": "date",
      "disabled": !_vm.isFieldEditable('promised_delivery_date')
    },
    domProps: {
      "value": _vm.value.promised_delivery_date
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "promised_delivery_date", $event.target.value);
      }
    }
  }), _c('small', [_c('a', {
    staticClass: "text-lowercase",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.value.promised_delivery_date = '';
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.empty')))])])]) : _vm.showEnabledFilter === 'address_type' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "address_type"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.address_type)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.address_type,
      expression: "value.address_type"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "address_type",
      "name": "address_type",
      "disabled": !_vm.isFieldEditable('address_type')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "address_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.addressTypes, function (type) {
    return _c('option', {
      domProps: {
        "value": type.identifier
      }
    }, [_vm._v(_vm._s(type.display_name))]);
  })], 2)]) : _vm.showEnabledFilter === 'address_name' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "address_name"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.address_name)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.address_name,
      expression: "value.address_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.address_name !== ''
    },
    attrs: {
      "id": "address_name",
      "placeholder": _vm.$t('omt.gui.orders.search.filters.placeholder.name'),
      "name": "address_name",
      "type": "text",
      "disabled": !_vm.isFieldEditable('address_name')
    },
    domProps: {
      "value": _vm.value.address_name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "address_name", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm.showEnabledFilter === 'address_city' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "address_city"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.address_city)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.address_city,
      expression: "value.address_city",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.address_city !== ''
    },
    attrs: {
      "id": "address_city",
      "placeholder": _vm.$t('omt.gui.orders.search.filters.placeholder.city'),
      "name": "address_city",
      "type": "text",
      "disabled": !_vm.isFieldEditable('address_city')
    },
    domProps: {
      "value": _vm.value.address_city
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "address_city", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm.showEnabledFilter === 'address_zipcode' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "address_city"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.address_zipcode)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.address_zipcode,
      expression: "value.address_zipcode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.address_zipcode !== ''
    },
    attrs: {
      "id": "address_city",
      "placeholder": _vm.$t('omt.gui.orders.search.filters.placeholder.zipcode'),
      "name": "address_zipcode",
      "type": "text",
      "disabled": !_vm.isFieldEditable('address_zipcode')
    },
    domProps: {
      "value": _vm.value.address_zipcode
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "address_zipcode", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm.showEnabledFilter === 'address_email' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "address_email"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.address_email)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.address_email,
      expression: "value.address_email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.address_email !== ''
    },
    attrs: {
      "id": "address_email",
      "placeholder": _vm.$t('omt.gui.orders.search.filters.placeholder.email'),
      "name": "address_email",
      "type": "email",
      "disabled": !_vm.isFieldEditable('address_email')
    },
    domProps: {
      "value": _vm.value.address_email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "address_email", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm.showEnabledFilter === 'address_country' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "address_country"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.address_country)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.address_country,
      expression: "value.address_country",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.address_country !== ''
    },
    attrs: {
      "id": "address_country",
      "name": "address_country",
      "disabled": !_vm.isFieldEditable('address_country')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "address_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.countries, function (name, identifier) {
    return _c('option', {
      domProps: {
        "value": identifier
      }
    }, [_vm._v(_vm._s(name))]);
  })], 2)]) : _vm.showEnabledFilter === 'customer_identifier' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "customer_identifier"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.customer_identifier)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.customer_identifier,
      expression: "value.customer_identifier"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.customer_identifier !== ''
    },
    attrs: {
      "id": "customer_identifier",
      "name": "customer_identifier",
      "type": "text",
      "disabled": !_vm.isFieldEditable('customer_identifier')
    },
    domProps: {
      "value": _vm.value.customer_identifier
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "customer_identifier", $event.target.value);
      }
    }
  })]) : _vm.showEnabledFilter === 'dispatch_request_batch' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "batch_identifier"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.dispatch_request_batch_identifier)))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.dispatch_request_batch,
      expression: "value.dispatch_request_batch"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.dispatch_request_batch !== ''
    },
    attrs: {
      "id": "batch_identifier",
      "name": "dispatch_request_batch",
      "type": "text",
      "disabled": !_vm.isFieldEditable('dispatch_request_batch_identifier')
    },
    domProps: {
      "value": _vm.value.dispatch_request_batch
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "dispatch_request_batch", $event.target.value);
      }
    }
  })]) : _vm.showEnabledFilter === 'is_paused' ? _c('b-col', [_c('label', {
    attrs: {
      "for": "customer_identifier"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.FILTER_COLUMN_DISPLAY_NAMES.is_paused)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.is_paused,
      expression: "value.is_paused"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.value.is_paused !== ''
    },
    attrs: {
      "id": "is_paused",
      "name": "is_paused",
      "disabled": !_vm.isFieldEditable('is_paused')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "is_paused", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ja")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Nee")])])]) : !_vm.showFilter ? _c('b-col', [_vm._v(" ")]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }